<template lang="pug">
v-menu(offset-y, open-on-hover)
  template(v-slot:activator="{ on }")
    v-avatar.btn-login(v-on="on")
      v-icon(size="40") far fa-user-circle
  v-list(flat)
    v-list-item(link, :to="`/users/${user.username}`", color="secondary")
      v-list-item-icon
        v-icon fa-user
      v-list-item-content
        v-list-item-title Perfil
    v-list-item(
      v-if="user.role.slug == 'owner'",
      v-for="(n, i) in nav_owner",
      :key="i",
      link,
      :to="n.path",
      color="secondary"
    )
      v-list-item-icon
        v-icon(v-text="n.icon")
      v-list-item-content
        v-list-item-title(v-text="n.text")
    v-list-item(
      v-if="user.role.slug == 'vet'",
      v-for="(n, i) in nav_vet",
      :key="i",
      link,
      :to="n.path",
      color="secondary"
    )
      v-list-item-icon
        v-icon(v-text="n.icon")
      v-list-item-content
        v-list-item-title(v-text="n.text")
    v-list-item(
      v-if="user.role.slug == 'admin'",
      v-for="(n, i) in nav_admin",
      :key="i",
      link,
      :to="n.path",
      color="secondary"
    )
      v-list-item-icon
        v-icon(v-text="n.icon")
      v-list-item-content
        v-list-item-title(v-text="n.text")
    v-list-item(v-if="user.role.slug != 'owner'", to="/email", link)
      v-list-item-icon
        v-icon fa-envelope
      v-list-item-content
        v-list-item-title Correos
    v-divider
    v-list-item(@click="signOut")
      v-list-item-icon
        v-icon fa-sign-out-alt
      v-list-item-content
        v-list-item-title Cerrar Sesión
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "menu-user",
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  data() {
    return {
      nav_admin: [
        { icon: "fa-paw", text: "Mascotas", path: "/pets" },
        { icon: "fa-cubes", text: "Stock", path: "/stock" },
        { icon: "fa-users", text: "Usuarios", path: "/users" },
        { icon: "fa-dog", text: "Especies", path: "/species" },
        { icon: "fa-boxes", text: "Inventario", path: "/inventories" },
        { icon: "fa-truck-loading", text: "Proveedores", path: "/providers" },
      ],
      nav_vet: [
        { icon: "fa-paw", text: "Mascotas", path: "/pets" },
        { icon: "fa-users", text: "Propietarios", path: "/users" },
        { icon: "fa-boxes", text: "Inventario", path: "/inventories" },
        { icon: "fas fa-syringe", text: "Vacunas", path: "/vaccinations" },
        {
          icon: "fa-calendar-alt",
          text: "Citas Médicas",
          path: "/appointments",
        },
        {
          icon: "fas fa-plus-square",
          text: "Historial Médico",
          path: "/medical_histories",
        },
      ],
      nav_owner: [
        { icon: "fa-paw", text: "Mis Mascotas", path: "/pets" },
        {
          icon: "fa-calendar-alt",
          text: "Mis Citas Médicas",
          path: "/appointments",
        },
      ],
    };
  },
  methods: {
    signOut() {
      window.localStorage.removeItem("auth_token");
      this.$store.commit("auth/setTokenAuth", null);
      this.$router.push(`/`);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-login {
  margin-left: 10px;
}
</style>
